<template>

    <rkm-tabs
        v-model="tabIndex"
        :tab-refs="tabRefs"
    >
        <rkm-tab
            key="cadastro"
            title="Cadastro individual"
        >
            <TabCadastroIndividual
                ref="TabCadastroIndividual"
                :data="data"
            />
        </rkm-tab>

        <rkm-tab
            key="questionario"
            title="Questionário da saúde"
        >
            <TabQuestionarioSaude
                ref="TabQuestionarioSaude"
                :data="data"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>

// Components.
import TabCadastroIndividual from './components/cadastro/Form'
import TabQuestionarioSaude from './components/questionario/Form'

export default {
    components: {
        TabCadastroIndividual,
        TabQuestionarioSaude,
    },
    props: {
        data: { type: Object, required: true },
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabCadastroIndividual,
            this.$refs.TabQuestionarioSaude,
        ]
    }
}
</script>